import { DatePipe, registerLocaleData } from '@angular/common';
import localeCa from '@angular/common/locales/ca';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { getSpanishTimezoneUTC } from '@app/modules/shared/const/date-picker.consts';

@Pipe({
  name: 'localizedDate',
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string, pattern: string = 'mediumDate'): string {
    let locale;

    if (this.translateService.currentLang === 'fr') {
      locale = localeFr;
    } else if (this.translateService.currentLang === 'en') {
      locale = localeEn;
    } else if (this.translateService.currentLang === 'ca') {
      locale = localeCa;
    } else {
      locale = localeEs;
    }

    registerLocaleData(locale, this.translateService.currentLang);

    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
    return datePipe.transform(value, pattern, getSpanishTimezoneUTC(value));
  }
}
